import ResizeObserverPonyFill from 'resize-observer-polyfill';

let observe, unobserve;

// Modern browsers can use a ResizeObserver to figure out when an element changes size
// Safari still doesn't have it
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = ResizeObserverPonyFill;
}

if (typeof window !== 'undefined' && window.ResizeObserver) {
  // key = DOM element, value = callback when element changes size
  const CALLBACK_MAP = new Map();

  const observer = new ResizeObserver(function(entries) {
    entries.forEach(function(entry) {
      const callback = CALLBACK_MAP.get(entry.target);

      if (!callback) {
        console.error('Cannot find callback for element', entry.target);
        return;
      }

      callback(entry.contentRect);
    });
  });

  observe = (el, callback) => {
    if (CALLBACK_MAP.has(el)) {
      console.error('element already being observed', el);
      return;
    }

    CALLBACK_MAP.set(el, callback);
    observer.observe(el);
  };

  unobserve = el => {
    if (!CALLBACK_MAP.has(el)) {
      return;
    }

    CALLBACK_MAP.delete(el);
    observer.unobserve(el);
  };
}

export default {
  observe: observe,
  unobserve: unobserve,
};
